import { useState, useEffect } from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getCurrentUser } from "aws-amplify/auth";

const SendMonthlySnapshotReport = () => {
  const navigate = useNavigate();
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await getCurrentUser();
        if (user && user.username === "fidel_cinco") {
          setShowButton(true);
        }
      } catch (error) {
        console.error("Error checking user:", error);
        setShowButton(false);
      }
    };
    checkUser();
  }, []);

  const handleOpen = () => {
    navigate("/send-monthly-snapshot/confirm");
  };

  if (!showButton) {
    return null;
  }

  return (
    <Button variant="contained" className="sm:!mx-6" onClick={handleOpen}>
      Send Monthly Snapshot Report
    </Button>
  );
};

export default SendMonthlySnapshotReport;
